import { render } from "./courseServiceInfo.vue?vue&type=template&id=a0f98b84&scoped=true"
import script from "./courseServiceInfo.vue?vue&type=script&lang=js"
export * from "./courseServiceInfo.vue?vue&type=script&lang=js"

import "./courseServiceInfo.vue?vue&type=style&index=0&id=a0f98b84&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f98b84"]])

export default __exports__